import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';

class NoCredentialsStore implements ICredentialsStore {
    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return {};
    }
}

export default NoCredentialsStore;
